import { render, staticRenderFns } from "./IconError.vue?vue&type=template&id=4eb12ce0&scoped=true&lang=pug"
import script from "./IconError.vue?vue&type=script&lang=js"
export * from "./IconError.vue?vue&type=script&lang=js"
import style0 from "./IconError.vue?vue&type=style&index=0&id=4eb12ce0&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb12ce0",
  null
  
)

export default component.exports